import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=df1e7fde&scoped=true&"
import script from "./ActivityDetail.vue?vue&type=script&lang=js&"
export * from "./ActivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1e7fde",
  null
  
)

export default component.exports